import Squad from './squad.png';
import Vision from './vision.png';
import Mission from './mission.png';
import FirstRowA from './firstrow-a.png';
import FirstRowB from './firstrow-b.png';
import SecondRowA from './secondrow-a.png';
import SecondRowB from './secondrow-b.png';
import ThirdRowA from './thirdrow-a.png';
import ThirdRowB from './thirdrow-b.png';
import FourthRow from './fourthrow.jpeg';

const AboutImages = {
  Squad,
  Vision,
  Mission,
  FirstRowA,
  FirstRowB,
  SecondRowA,
  SecondRowB,
  ThirdRowA,
  ThirdRowB,
  FourthRow,
};

export default AboutImages;
